export default [
  {
    path: '/elementer/list',
    name: 'elementer-list',
    component: () => import('@/views/elementer/index.vue'),
    meta: {
      action: 'read',
      subject: 'elementer',
      public: false,
      title: 'elementer.Baslik',
      yetki: { k: [2003102] },
    },
  },
]
